import { useMutation } from '@tanstack/react-query'

import { redeemGroupCode } from '../dal/group-code-dal'

export function useRedeemGroupCode() {
  return useMutation({
    mutationFn: redeemGroupCode,
  })
}
